export function validTelephone(phone: string): boolean {
  const pattern = /^\(?([0-9]{2})\)?\s?([0-9]{4})-?([0-9]{4})$/;
  if (!phone) {
    return false;
  }
  return pattern.test(phone);
}
